
import React from 'react';
import { 
  Table, 
  TableBody, 
  TableCaption, 
  TableCell, 
  TableHead, 
  TableHeader, 
  TableRow 
} from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Trash2, Star, StarOff, Check, X } from 'lucide-react';
import { CompanyDomain } from '@/types/company';
import { formatDate } from '@/lib/utils';

interface DomainTableProps {
  domains: CompanyDomain[];
  onDeleteDomain: (domain: CompanyDomain) => void;
  onSetPrimary: (domainId: string) => void;
}

export function DomainTable({ domains, onDeleteDomain, onSetPrimary }: DomainTableProps) {
  if (!domains || domains.length === 0) {
    return (
      <div className="text-center py-8 border rounded-md bg-muted/20">
        <p className="text-muted-foreground">No hay dominios registrados</p>
      </div>
    );
  }

  return (
    <Table>
      <TableCaption>Dominios registrados para la empresa</TableCaption>
      <TableHeader>
        <TableRow>
          <TableHead>Dominio</TableHead>
          <TableHead>Estado</TableHead>
          <TableHead>Principal</TableHead>
          <TableHead>Fecha de registro</TableHead>
          <TableHead className="text-right">Acciones</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {domains.map((domain) => (
          <TableRow key={domain.id}>
            <TableCell className="font-medium">{domain.domain}</TableCell>
            <TableCell>
              {domain.isActive ? (
                <Badge variant="outline" className="bg-green-100 text-green-800 hover:bg-green-200">
                  <Check size={14} className="mr-1" />
                  Activo
                </Badge>
              ) : (
                <Badge variant="outline" className="bg-gray-100 text-gray-800 hover:bg-gray-200">
                  <X size={14} className="mr-1" />
                  Inactivo
                </Badge>
              )}
            </TableCell>
            <TableCell>
              {domain.isPrimary ? (
                <Badge className="bg-blue-100 text-blue-800 hover:bg-blue-200">
                  <Star size={14} className="mr-1" />
                  Principal
                </Badge>
              ) : (
                <Button 
                  variant="ghost" 
                  size="sm"
                  onClick={() => onSetPrimary(domain.id)}
                >
                  <StarOff size={14} className="mr-1" />
                  Establecer
                </Button>
              )}
            </TableCell>
            <TableCell>{formatDate(domain.createdAt.toString())}</TableCell>
            <TableCell className="text-right">
              {!domain.isPrimary && (
                <Button
                  variant="ghost"
                  size="sm"
                  className="text-red-500 hover:text-red-700 hover:bg-red-50"
                  onClick={() => onDeleteDomain(domain)}
                >
                  <Trash2 size={16} />
                </Button>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
